<template>
  <div
    :class="
      `${bg} ${text} ${border} hover:${bgHover} relative inline-flex rounded-full border border-opacity-25 ml-1 p-2 ${enableClick ? 'cursor-pointer' : ''} transition-all ease-in-out duration-300 `
    "
  >
    <div 
      v-if="enableClick" 
      @click.stop="$emit('buttonClick')"
      class="absolute w-full h-full top-0 left-0 z-10"
    />
    <icon
      :name="icon" 
      class="w-2 h-2 xl:h-4 xl:w-4 transition ease-in-out duration-150" 
      :class="'transform scale-'+iconSize"
      :label="label"
    />
  </div>
</template>

<script>
import Icon from './Icon';

export default {
  props:{ 
    icon:{
      type: String, 
    },
    bgColor:{
      type: String,
    },
    iconColor:{
      type: String,
    },
    borderColor:{
      type: String,
    },
    bgColorHover:{
      type: String,
    },
    iconScale:{
      type: String,
    },
    label:{
      type: String,
    },
    enableClick:{
      type: Boolean,
      required: false,
      default: true
    }
  },

  components:{
    Icon,
  },
    
  data: function () {
    return {
      bg: 'bg-pink-100',
      text: 'text-indigo-600',
      border: 'border-pink-600',
      bgHover: 'bg-pink-300',
      iconSize: '100',
    };
  },
  mounted(){
    if(this.bgColor != undefined){
      this.bg= this.bgColor;
    }
    if(this.iconColor != undefined){
      this.text= this.iconColor;
    }
    if(this.borderColor != undefined){
      this.border= this.borderColor;
    }
    if(this.bgColorHover != undefined){
      this.bgHover= this.bgColorHover;
    }
    if(this.iconScale != undefined){
      this.iconSize= this.iconScale;
    }
  }
};
</script>